export default __webpack_public_path__ + "static/media/investorSteveJobs.f7e3284b.wav";